import { IDecisionListFilterExtraField } from '../interfaces/IDecisionListFilterExtraField';

export const initialDecisionListAdditionalFields: IDecisionListFilterExtraField[] = [
  {
    id: 'supervisionType',
    name: 'Вид государственного контроля (надзора)',
    isSelected: false,
    type: 'select',
    isSearchable: true,
    isClearable: true,
  },
  {
    id: 'reasons',
    name: 'Основание проведения мероприятия',
    isSelected: false,
    isSearchable: true,
    type: 'select',
    isMulti: true,
  },
  {
    id: 'subjectTypes',
    name: 'Тип проверяемого лица',
    isSelected: false,
    type: 'select',
    isMulti: true,
  },
  {
    id: 'subjectOrgName',
    name: 'Наименование проверяемого лица',
    isSelected: false,
    type: 'text',
  },
  {
    id: 'subjectOgrn',
    name: 'ОГРН проверяемого лица',
    isSelected: false,
    type: 'text',
  },
  {
    id: 'subjectInn',
    name: 'ИНН проверяемого лица',
    isSelected: false,
    type: 'text',
  },
  {
    id: 'subjectKpp',
    name: 'КПП проверяемого лица',
    isSelected: false,
    type: 'text',
  },
  {
    id: 'subjectCountries',
    name: 'Страна проверяемого лица',
    isSelected: false,
    type: 'select',
    isMulti: true,
  },
  {
    id: 'objectAddress',
    name: 'Местонахождение объекта',
    isSelected: false,
    type: 'text',
  },
  {
    id: 'objectTypes',
    name: 'Тип объекта контроля',
    isSelected: false,
    type: 'select',
    isMulti: true,
  },
  {
    id: 'objectKinds',
    name: 'Вид объекта контроля',
    isSelected: false,
    type: 'select',
    isMulti: true,
  },
  {
    id: 'objectSubKinds',
    name: 'Подвид объекта контроля',
    isSelected: false,
    type: 'select',
    isMulti: true,
  },
  {
    id: 'objectRiskCategory',
    name: 'Категория риска',
    isSelected: false,
    type: 'select',
  },
  {
    id: 'objectDangerClass',
    name: 'Класс опасности',
    isSelected: false,
    type: 'select',
  },
  {
    id: 'signed',
    name: 'Статус подписания',
    isSelected: false,
    type: 'select',
  },
  {
    id: 'statuses',
    name: 'Статус решения',
    isSelected: false,
    type: 'select',
    isMulti: true,
  },
  {
    id: 'pubStatuses',
    name: 'Статус публикации',
    isSelected: false,
    type: 'select',
    isMulti: true,
  },
  {
    id: 'prosecutorOrganizations',
    name: 'Орган прокуратуры',
    isSelected: false,
    type: 'select',
    isMulti: true,
  },
  {
    id: 'number',
    name: 'Учетный номер решения',
    isSelected: false,
    type: 'text',
  },
  {
    id: 'deletedInclude',
    name: 'Показывать удаленные решения',
    isSelected: false,
    type: 'select',
  },
  {
    id: 'deletedOnly',
    name: 'Показывать только удаленные решения',
    isSelected: false,
    type: 'select',
  },
];

export const isTestAdditionalField: IDecisionListFilterExtraField = {
  id: 'isTest',
  name: 'Тестовый',
  isSelected: false,
  type: 'select',
};
